import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as fromSignin from '@app/client/signin/store/reducers';
import * as fromRoot from '@app/reducers';
import { Store, select } from '@ngrx/store';
import { Observable, first, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MfaCanActivateGuard {
  constructor(
    private store$: Store<fromRoot.State & fromSignin.State>,
    private router: Router,
  ) { }

  canActivate(): Observable<boolean> {
    return this.isMfaRequired().pipe(first(), map((mfaRequired) => {
      if (!mfaRequired) {
        this.router.navigate(['/signin']);
        return false;
      }
      return true;
    }));
  }

  isMfaRequired(): Observable<boolean> {
    return this.store$.select(fromSignin.getMfaRequired);
  }
}
